<template>
	<div class="notFound wrapper">
		<img src="../../assets/images/user/sorry.png" alt="" /></br>
		<img src="../../assets/images/user/nofound2.png" alt="" /></br>
		<p>
			没有找到相关信息
		</p>
	</div>

</template>

<script>
    export default {
    	name: 'notFound',
    }
</script>